var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.toasts),function(toast,index){return _c('li',{key:index,class:toast.type},[_vm._v(" "+_vm._s(toast.message)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }